import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import TimetableSyncLogs from "./routes/TimetableSyncLogs";
import PeriodsMapping from "./routes/PeriodsMapping";

export default store => ({
  path: "schedule",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-schoolSetup-integrations" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;

        // would have to add redux store here
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [TimetableSyncLogs(store), PeriodsMapping(store)],
});
